import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const ModalDetalle = ({ show, onHide, ocurrencia, modoEdicion, onGuardar, empleados }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (ocurrencia) {
            setFormData({ ...ocurrencia });
        }
    }, [ocurrencia]);

    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return "";
        try {
            if (typeof fecha === "string" && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
                const [year, month, day] = fecha.split("-");
                return `${day}/${month}/${year}`;
            }
            if (fecha && fecha.toDate) return fecha.toDate().toLocaleDateString("es-PE");
            return new Date(fecha).toLocaleDateString("es-PE");
        } catch { return fecha; }
    };

    const obtenerNombreEmpleado = (id) => {
        const emp = empleados.find(e => e.dni === id || e.id === id);
        return emp ? `${emp.nombres} ${emp.apellidos}` : id;
    };

    if (!ocurrencia) return null;

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {modoEdicion ? "Editar Ocurrencia" : "Detalle de Ocurrencia"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Empleado</Form.Label>
                            <Form.Control
                                type="text"
                                value={obtenerNombreEmpleado(formData.empleado_id)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha</Form.Label>
                            <Form.Control
                                type="text"
                                value={formatearFecha(formData.fecha)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Tipo</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.tipo}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Estado</Form.Label>
                            <Form.Select
                                value={formData.estado}
                                onChange={(e) => handleChange("estado", e.target.value)}
                                disabled={!modoEdicion}
                            >
                                <option value="pendiente">Pendiente</option>
                                <option value="aprobado">Aprobado</option>
                                <option value="rechazado">Rechazado</option>
                                <option value="detectado_automatico">Detectado Automático</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Justificado</Form.Label>
                            <Form.Select
                                value={formData.justificado}
                                onChange={(e) => handleChange("justificado", e.target.value === "true")}
                                disabled={!modoEdicion}
                            >
                                <option value={true}>Sí</option>
                                <option value={false}>No</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Con Goce de Haber</Form.Label>
                            <Form.Select
                                value={formData.con_goce}
                                onChange={(e) => handleChange("con_goce", e.target.value === "true")}
                                disabled={!modoEdicion}
                            >
                                <option value={true}>Sí</option>
                                <option value={false}>No</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Motivo</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formData.motivo || ""}
                                onChange={(e) => handleChange("motivo", e.target.value)}
                                disabled={!modoEdicion}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Observaciones</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formData.observaciones || ""}
                                onChange={(e) => handleChange("observaciones", e.target.value)}
                                disabled={!modoEdicion}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <hr />
                        <h6>Información Adicional</h6>
                        <Row>
                            <Col md={4}>
                                <small><strong>Días afectados:</strong> {formData.dias_afectados || 0}</small>
                            </Col>
                            <Col md={4}>
                                <small><strong>Horas afectadas:</strong> {formData.horas_afectadas || 0}</small>
                            </Col>
                            <Col md={4}>
                                <small><strong>Minutos tardanza:</strong> {formData.minutos_tardanza || 0}</small>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                {modoEdicion && (
                    <Button variant="primary" onClick={() => onGuardar(formData)}>
                        Guardar Cambios
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDetalle;
